// src/utils/currencyFormatter.js

/**
 * Formata um valor numérico para o formato de moeda brasileiro (BRL) sem símbolo.
 * Ex: 1500.30 -> "1.500,30"
 * @param {number | null | undefined} value O valor numérico a ser formatado.
 * @returns {string} O valor formatado como string, ou "0,00" se o valor for nulo/indefinido.
 */
export const formatCurrency = (value) => {
  if (value === null || value === undefined) {
    return '0,00';
  }
  // Usar Intl.NumberFormat para formatação robusta e localizada
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
};

/**
 * Formata um valor numérico para o formato de moeda brasileiro com símbolo (R$).
 * Ex: 1500.30 -> "R$ 1.500,30"
 * @param {number | null | undefined} value O valor numérico a ser formatado.
 * @returns {string} O valor formatado como string, ou "R$ 0,00" se o valor for nulo/indefinido.
 */
export const formatBRL = (value) => {
  const parsed = (value === null || value === undefined) ? 0 : (typeof value === 'number' ? value : parseFloat(value) || 0);
  const n = Number.isFinite(parsed) ? parsed : 0;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(n);
};